import { AgsResultBuilder } from "ags/integration/builders/results/abstract-ags-result-builder";
import { SparkResult } from "ags/integration/model/results/spark-result";
import { AgsEvent } from "ags/integration/schema/ags-spin-response-schema";
import { Record } from "appworks/model/gameplay/records/record";
import { Result } from "appworks/model/gameplay/records/results/result";
import { ResultBuilder } from "appworks/server/builders/result-builder";
import { Point } from "appworks/utils/geom/point";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";
import { slotDefinition } from "slotworks/model/slot-definition";

export class SparkResultBuilder extends AgsResultBuilder implements ResultBuilder {
    public filter(data: any): boolean {
        const event = data as AgsEvent;
        return event.id && event.id.toLowerCase() === "spark";
    }

    public build(record: Record, data: any): Result[] {
        const sparkWin = data as AgsEvent;

        const sparkResult = new SparkResult();
        sparkResult.emitPositions = [];
        sparkResult.positions = [];

        for (const position of sparkWin.positions) {
            sparkResult.emitPositions.push(new Point(position[0], position[1]));
        }

        // BB-67 - Front end now decides what a spark win should look like (shows all wilds after a bonus)
        (record as SpinRecord).grid.forEach((reel, col) => {
            reel.forEach((symbol, row) => {
                const symbolDefinition = slotDefinition.getSymbolDefinition(symbol);
                if (symbolDefinition.wild) {
                    sparkResult.positions.push(new Point(col, row));
                }
            });
        });

        sparkResult.upgrade = sparkWin.upgrade;
        sparkResult.state = sparkWin.state;

        return [sparkResult];
    }
}
